import { EmbedUrlRequest, EmbedUrlResponse } from 'vopay';
import { useApi } from '#shared/providers/Api';

// Feature-local Direct Pattern hook — exists only for ELinxConnect (relative import from it). Wraps
// postEmbedUrl and throws on a non-Success response so the caller can surface the failure (the legacy
// path failed silently — empty container, iframe never loads). Loading UI is raised by the component
// (ELinxConnect), per loading-conventions — the hook stays silent.
export default function useCreateEmbedUrl() {
  const api = useApi();

  async function createEmbedUrl(params: EmbedUrlRequest): Promise<EmbedUrlResponse> {
    try {
      const res = await api.postEmbedUrl(params);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  return { createEmbedUrl };
}
